import type { NetworkData } from "../types";

export interface NetworkActivations {
  inputs: number[];
  hidden: number[];
  outputs: number[];
}

export function forward(network: NetworkData, observation: number[]): NetworkActivations {
  const { input_size: inputSize, hidden_size: hiddenSize, output_size: outputSize } = network.architecture;
  if (observation.length !== inputSize) {
    throw new Error(`Observation has ${observation.length} inputs; expected ${inputSize}.`);
  }
  const hidden = Array.from({ length: hiddenSize }, (_, hiddenIndex) => {
    let value = network.bias_hidden[hiddenIndex] ?? 0;
    for (let inputIndex = 0; inputIndex < inputSize; inputIndex += 1) {
      value += (observation[inputIndex] ?? 0) * (network.weights_input_hidden[inputIndex]?.[hiddenIndex] ?? 0);
    }
    return Math.tanh(value);
  });
  const outputs = Array.from({ length: outputSize }, (_, outputIndex) => {
    let value = network.bias_output[outputIndex] ?? 0;
    for (let hiddenIndex = 0; hiddenIndex < hiddenSize; hiddenIndex += 1) {
      value += (hidden[hiddenIndex] ?? 0) * (network.weights_hidden_output[hiddenIndex]?.[outputIndex] ?? 0);
    }
    return Math.tanh(value);
  });
  return { inputs: [...observation], hidden, outputs };
}
